import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/components/WelcomeStatus'
import TableList from '@/components/TableList'
import Table from '@/components/Table'
import GenSecret from '@/components/GenSecret'
import UnlockSecret from '@/components/UnlockSecret'
import ConnectedDevices from '@/components/ConnectedDevices'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/tables',
      name: 'DynamoDB Tables',
      component: TableList
    },
    {
      path: '/table/:table',
      name: 'DaynamoDB Table',
      component: Table,
      props: true
    },
    {
      path: '/devices',
      name: 'Conneted Devices',
      component: ConnectedDevices
    },
    {
      path: '/gen-secret',
      name: 'Generate Secret',
      component: GenSecret
    },
    {
      path: '/unlock-secret',
      name: 'Unlock Secret',
      component: UnlockSecret
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js